// Per-league "last viewed entry" memory. Backed by localStorage so it survives
// reloads on the same device. SSR-safe and private-mode safe (try/catch).
//
// Used to make the Knockout / Groups tabs deep-link to the entry the user
// was last editing in this league, instead of always defaulting to the
// oldest one. For single-entry leagues this is effectively a no-op.

const KEY_PREFIX = "bg:lastEntry:";

export function getLastEntryId(leagueId: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(KEY_PREFIX + leagueId);
  } catch {
    return null;
  }
}

export function setLastEntryId(leagueId: string, entryId: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(KEY_PREFIX + leagueId, entryId);
  } catch {
    // ignore (quota / private mode)
  }
}
